import * as React from "react"

type PowerProps = { power: number }

export const InputPower: React.FC<PowerProps> = ({ power }) => {
  return <div style={{fontSize: "10px"}}>
    {power}W入力時
  </div>
}

export const OutputPower: React.FC<PowerProps> = ({ power }) => {
  return <div style={{fontSize: "10px"}}>
    {power}W
  </div>
}